// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"96":"ca5d1558","177":"9ce92c7c","215":"5ed2ccb2","268":"80857c34","279":"ce1ead3d","350":"941c6a71"}[chunkId] + ".css";
};